import React from "react";

import { ReactComponent } from "./chevron-down.svg";

export const ChevronDownIcon = () => {
  return <ReactComponent />;
};
